export default "__VITE_ASSET__e4bc7d5b__"